import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import DialogHeader from '../../../../components/basic/DialogHeader';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

let dialogStyles = {
    maxWidth: '1200px',
    maxheight: '750px',
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)'
};

class MinorCanabinoidDialogInput extends React.Component {
    state = {
        open: false
    };

    render() {
        const p = this.props;

        return (
            <div>
                <Dialog open={p.open} onClose={() => { }}>
                    <DialogTitle
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <h4 style={{padding: '5px 15px'}} >{p.title}</h4>

                        {  p.handleClose && <IconButton
                            aria-label="close"
                            onClick={() => {
                                p.handleClose();
                            }}
                        >
                            <CloseIcon />
                        </IconButton>}
                    </DialogTitle>
                    <DialogContent dividers >
                        {p.children}
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}

export default MinorCanabinoidDialogInput;
